/**
 * Returns the latest added non-upsell line item.
 */
export function getAddedLineItem(params: Params) {
  const { cartLineItems, upsellProducts } = params;

  const checkIfLineItemIsUpsell = checkIfLineItemIsNotUpsellFactory(upsellProducts); // prettier-ignore
  const lineItemsWithoutUpsells = cartLineItems.filter(checkIfLineItemIsUpsell); // prettier-ignore

  return lineItemsWithoutUpsells[lineItemsWithoutUpsells.length - 1];
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function checkIfLineItemIsNotUpsellFactory(upsellProducts: UpsellProduct[]) {
  const upsellProductIds = upsellProducts.map((product) => product.id);
  const upsellProductIdsSet = new Set(upsellProductIds);

  return (lineItem: LineItem) => !upsellProductIdsSet.has(lineItem.product.id);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  cartLineItems: LineItem[] | Readonly<LineItem[]>;
  upsellProducts: UpsellProduct[];
};

type UpsellProduct = { id: string };

type LineItem = {
  id: string;
  product: { id: string };
};
